import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createURL } from '@sm/utils';

import './pricing-navigation.scss';

const ROUTE_CONFIG = {
  teamsPricingPage: {
    path: '/pricing/teams/',
    title: 'Business Plans',
    queryString: {
      ut_source: 'pricing-summary',
    },
    packageType: 'teams',
  },
  individualPricingPage: {
    path: '/pricing/individual/',
    title: 'Personal Plans',
    queryString: {
      ut_source: 'pricing-summary',
    },
    packageType: 'individual',
  },
};
const ROUTE_KEYS = Object.keys(ROUTE_CONFIG);

const NavItem = ({ route, selected = false }) => (
  <a
    href={createURL(route.path, route.queryString)}
    className={classnames('sm-pricing-navigation__item', 'wds-type--card-title', {
      'sm-pricing-navigation__item--selected': selected,
    })}
  >
    {route.title}
  </a>
);
NavItem.propTypes = {
  route: PropTypes.shape({
    path: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    queryString: PropTypes.object,
    packageType: PropTypes.string.isRequired,
  }),
  selected: PropTypes.bool,
};
NavItem.defaultProps = {
  route: {
    queryString: null,
  },
  selected: false,
};

const PricingNavigation = ({ packageType = 'teams' }) => (
  <nav className="sm-pricing-navigation wds-m-b-7">
    {ROUTE_KEYS.map(routeName => {
      const route = ROUTE_CONFIG[routeName];
      return <NavItem route={route} selected={packageType === route.packageType} key={routeName} />;
    })}
  </nav>
);
PricingNavigation.propTypes = {
  packageType: PropTypes.string,
};
PricingNavigation.defaultProps = {
  packageType: 'teams',
};

export default PricingNavigation;
